import * as React from 'react'
import { ChildProps, compose } from 'react-apollo'
import { graphql } from 'react-apollo'
import { ApolloClient } from 'apollo-client'
import { NormalizedCache } from 'apollo-cache-inmemory'

import ProjectCase from './ProjectCase'

import {
  getWithProjectParameters,
  ProjectParametersResponse
} from './projectParameterQueries'

import { CASE_QUERY, CaseResponse } from '../Results/caseQuery'
import { SAVE_CASE, CaseInput, GET_REPORT_ACCESS_TOKEN } from './projectQueries'
import { ProjectCaseType } from '../../actions/project'

type ProjectCaseContainerProps = {
  projectCaseId: string
  lockTabs?: (lock: boolean) => void

  disabled?: boolean
}

type ProjectCaseResponse = {
  projectCase: ProjectCaseType
}

type Props = ChildProps<
  ProjectCaseContainerProps & ProjectCaseResponse,
  ProjectParametersResponse
>

type ClientContext = {
  client: ApolloClient<NormalizedCache>
}

// Loads and prepares data for ProjectCase. We make sure the case is "fully loaded"
// so we have access to the list of beams (we need to retrieve fire resistance from
// the beam).
class ProjectCaseContainer extends React.Component<Props> {
  // TODO: use <Mutation> instead when we move to react-apollo 2.1.x
  static contextTypes = {
    client: () => null
  }
  context: ClientContext

  saveCase = async (kase: CaseInput, spaceType: string, parameters: string) => {
    return this.context.client.mutate({
      mutation: SAVE_CASE,
      variables: { case: kase, spaceType: spaceType, params: parameters }
    })
  }

  getReportToken = async () => {
    return this.context.client.mutate({ mutation: GET_REPORT_ACCESS_TOKEN })
  }

  render() {
    const data = this.props.data

    if (
      !data ||
      !data.spaceTypes ||
      !data.fireResistances ||
      !data.executionTypes ||
      !data.finishingTypes ||
      !data.beamConcreteGrades ||
      !data.beamMaterials ||
      !data.beamExtras
    ) {
      return null
    }

    // We make sure ProjectCase doesn't have to deal with potentionally missing parameters
    const caseData: ProjectParametersResponse = {
      spaceTypes: data.spaceTypes,
      fireResistances: data.fireResistances,
      executionTypes: data.executionTypes,
      finishingTypes: data.finishingTypes,
      beamConcreteGrades: data.beamConcreteGrades,
      beamMaterials: data.beamMaterials,
      beamExtras: data.beamExtras
    }

    return (
      <ProjectCase
        data={caseData}
        projectCase={this.props.projectCase}
        saveCase={this.saveCase}
        getReportToken={this.getReportToken}
        lockTabs={this.props.lockTabs}
        disabled={this.props.disabled}
      />
    )
  }
}

export default compose(
  graphql<CaseResponse, ProjectCaseContainerProps>(CASE_QUERY, {
    options: props => ({ variables: { caseId: props.projectCaseId } }),
    props: props => ({
      projectCase: props.data ? props.data.case : null
    })
  }),
  getWithProjectParameters<ProjectCaseContainerProps & CaseResponse>()
)(ProjectCaseContainer)



// WEBPACK FOOTER //
// ./src/Components/Projects/ProjectCaseContainer.tsx